import '../css/GestionAdmin.css';
import React, { useEffect, useState } from "react";
import HeaderHomeAdmin from "../headers/headerHomeAdmin";
import { Button } from "react-bootstrap";
// import Card from "../components/card";
import { useHistory } from "react-router-dom";
import Footer from "../components/Footer";


function GestionAdmin(){
    const history = useHistory();

	return (
  <>
    <div className="min-vh-100 bg-light">
      <HeaderHomeAdmin />

      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold text-dark">
          Galeries
        </h2>

        <div className="row justify-content-center g-4">
          {/* Galerie */}
          <div className="col-12 col-md-4">
            <div
              className="card h-100 shadow-sm border-0 text-center cursor-pointer"
              onClick={() => history.push("/admin/gestion/galerie/public")}
            >
              <div className="card-body py-5">
                <div className="fs-1 mb-3">🌍</div>
                <h5 className="fw-semibold">Galerie Publique</h5>
                <p className="text-muted mb-0">
                  Images et souvenirs publique
                </p>
              </div>
            </div>
          </div>

          {/* Galerie */}
          <div className="col-12 col-md-4">
            <div
              className="card h-100 shadow-sm border-0 text-center cursor-pointer"
              onClick={() => history.push("/admin/gestion/galerie/members")}
            >
              <div className="card-body py-5">
                <div className="fs-1 mb-3">🔒</div>
                <h5 className="fw-semibold">Galerie Membres</h5>
                <p className="text-muted mb-0">
                  Images et souvenirs membres
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </>
);
}


export default GestionAdmin;